$padding: 24px;

.card {
  box-sizing: border-box;
  // Allow utility classes to override, keep this in stylesheet
  padding: $padding;
  border-radius: 20px;
  background: var(--container);
  transition: box-shadow var(--fast-s);

  // Top and bottom offsets allow for margin collapse
  .top-offset {
    height: 1px;
    margin-top: -1px;
    margin-bottom: $padding;
  }
  .bottom-offset {
    height: 1px;
    margin-top: $padding;
    margin-bottom: -1px;
  }

  &.raised {
    box-shadow: 2px 4px 8px 0 var(--outline);
  }

  &.dugout {
    background: var(--dugout);
  }
  &.marginCollapsible {
    padding: 0 $padding;
  }
}

.card-item.card-item {
  // TODO: Get proper element height
  height: 1.5em;
  margin: 24px 0;
}

.padding {
  &.all {
    padding: $padding;
  }
  &.top {
    padding-top: $padding;
  }
  &.right {
    padding-right: $padding;
  }
  &.bottom {
    padding-bottom: $padding;
  }
  &.left {
    padding-left: $padding;
  }
}

.escape-padding {
  &.all {
    margin: calc(-1 * $padding);
  }
  &.top {
    margin-top: calc(-1 * $padding);
  }
  &.right {
    margin-right: calc(-1 * $padding);
  }
  &.bottom {
    margin-bottom: calc(-1 * $padding);
  }
  &.left {
    margin-left: calc(-1 * $padding);
  }
}
